// Inventory status function
function updateInventoryStatus(variant, maxQuantity, inventoryStatus, inventoryMessage) {
  if (!inventoryStatus || !inventoryMessage) return;
  
  // Hide inventory status message
  inventoryStatus.style.display = 'none';
}

// Get available inventory function
async function getAvailableInventory(variantId, productVariants) {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    const existingInCart = cart.items.find(item => item.variant_id === variantId)?.quantity || 0;
    const variant = productVariants.find(v => v.id == variantId);
    
    if (variant && variant.inventory_management === 'shopify' && variant.inventory_quantity !== undefined) {
      const available = variant.inventory_quantity - existingInCart;
      return Math.max(0, available);
    }
    
    return 999; // No inventory tracking
  } catch (error) {
    console.error('Error fetching cart:', error);
    return 999;
  }
}

// Quantity functionality
async function updateQuantity(button, change, productVariants, sectionId) {
  try {
    const input = button.parentElement.querySelector('.quantity-input');
    if (!input) return;
    
    const currentValue = parseInt(input.value) || 1;
    const variantIdInput = document.querySelector('.variant-id');
    
    let currentVariant;
    if (variantIdInput && variantIdInput.value) {
      currentVariant = productVariants.find(variant => variant.id == variantIdInput.value);
    }
    
    if (!currentVariant) {
      currentVariant = productVariants.find(variant => variant.available) || productVariants[0];
    }
    
    const maxQuantity = 10;
    const newValue = Math.max(1, Math.min(maxQuantity, currentValue + change));
    
    input.value = newValue;
    
    const minusButton = button.parentElement.querySelector('.quantity-minus');
    const plusButton = button.parentElement.querySelector('.quantity-plus');
    
    if (minusButton) minusButton.disabled = newValue <= 1;
    if (plusButton) plusButton.disabled = newValue >= maxQuantity;
    
    const inventoryStatus = document.getElementById(`inventory-status-${sectionId}`);
    const inventoryMessage = inventoryStatus?.querySelector('.inventory-message');
    updateInventoryStatus(currentVariant, maxQuantity, inventoryStatus, inventoryMessage);
  } catch (error) {
    console.error('Error in updateQuantity:', error);
  }
}

// Product Gallery functionality
class ProductGallery {
  constructor(element) {
    this.gallery = element;
    this.currentSlide = 0;
    this.allSlides = element.querySelectorAll('.product-slide');
    this.allDots = element.querySelectorAll('.product-dot');
    this.prevBtn = element.querySelector('.product-nav-prev');
    this.nextBtn = element.querySelector('.product-nav-next');
    this.dotsContainer = element.querySelector('.product-dots');
    this.navigationContainer = element.querySelector('.gallery-navigation');
    this.selectedColor = '';
    this.filteredSlides = [];
    this.filteredDots = [];
    
    this.init();
  }
  
  init() {
    this.filterByColor('');
    this.prevBtn?.addEventListener('click', () => this.goToPrev());
    this.nextBtn?.addEventListener('click', () => this.goToNext());
    this.bindDotEvents();
    
    this.gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.goToPrev();
      if (e.key === 'ArrowRight') this.goToNext();
    });
    
    this.gallery.setAttribute('tabindex', '0');
    
    // Mark gallery as initialized to enable CSS transitions
    this.gallery.classList.add('initialized');
  }
  
  bindDotEvents() {
    this.filteredDots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
  }
  
  filterByColor(selectedColor) {
    this.selectedColor = selectedColor;
    this.gallery.setAttribute('data-selected-color', selectedColor);
    
    if (!selectedColor) {
      this.filteredSlides = Array.from(this.allSlides);
      this.filteredDots = Array.from(this.allDots);
      this.allSlides.forEach(slide => slide.style.display = 'block');
      this.allDots.forEach(dot => dot.style.display = 'block');
    } else {
      const normalizedColor = selectedColor.toLowerCase().trim();
      
      this.filteredSlides = Array.from(this.allSlides).filter(slide => {
        const slideColor = slide.getAttribute('data-color');
        const matches = slideColor && slideColor.includes(normalizedColor);
        slide.style.display = matches ? 'block' : 'none';
        return matches;
      });
      
      this.filteredDots = Array.from(this.allDots).filter(dot => {
        const dotColor = dot.getAttribute('data-color');
        const matches = dotColor && dotColor.includes(normalizedColor);
        dot.style.display = matches ? 'block' : 'none';
        return matches;
      });
    }
    
    this.updateNavigationVisibility();
    this.currentSlide = 0;
    this.showCurrentSlide();
    this.bindDotEvents();
  }
  
  updateNavigationVisibility() {
    const hasMultipleImages = this.filteredSlides.length > 1;
    
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.style.display = hasMultipleImages ? 'flex' : 'none';
      this.nextBtn.style.display = hasMultipleImages ? 'flex' : 'none';
    }
    
    if (this.dotsContainer) {
      this.dotsContainer.parentElement.style.display = hasMultipleImages ? 'flex' : 'none';
    }
  }
  
  showCurrentSlide() {
    this.filteredSlides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.classList.remove('opacity-0');
        slide.classList.add('opacity-100');
      } else {
        slide.classList.remove('opacity-100');
        slide.classList.add('opacity-0');
      }
    });
    
    this.filteredDots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.remove('bg-black/10');
        dot.classList.add('bg-black/50');
      } else {
        dot.classList.remove('bg-black/50');
        dot.classList.add('bg-black/10');
      }
    });
    
    this.gallery.setAttribute('data-current-slide', this.currentSlide);
  }
  
  goToSlide(index) {
    if (index === this.currentSlide || index < 0 || index >= this.filteredSlides.length) return;
    this.currentSlide = index;
    this.showCurrentSlide();
  }
  
  goToNext() {
    if (this.filteredSlides.length <= 1) return;
    const nextIndex = (this.currentSlide + 1) % this.filteredSlides.length;
    this.goToSlide(nextIndex);
  }
  
  goToPrev() {
    if (this.filteredSlides.length <= 1) return;
    const prevIndex = (this.currentSlide - 1 + this.filteredSlides.length) % this.filteredSlides.length;
    this.goToSlide(prevIndex);
  }
  
  scrollToColorImage(selectedColor) {
    this.filterByColor(selectedColor);
  }
}

// Global function to advance to next image
window.nextProductImage = function() {
  if (window.galleryInstance) {
    window.galleryInstance.goToNext();
  }
};

// Initialize product hero
function initProductHero(productVariants, sectionId, moneyFormat) {
  const productGallery = document.querySelector('.product-gallery');
  if (productGallery) {
    window.galleryInstance = new ProductGallery(productGallery);
  }
  
  const sizeInputs = document.querySelectorAll('.size-input');
  const colorInputs = document.querySelectorAll('.color-input');
  const variantIdInput = document.querySelector('.variant-id');
  
  // Ensure walnut is selected on load
  const walnutInput = Array.from(colorInputs).find(input => 
    input.value.toLowerCase() === 'walnut'
  );
  if (walnutInput && !document.querySelector('.color-input:checked')) {
    walnutInput.checked = true;
    setTimeout(() => {
      updateColorStyles(colorInputs);
      updateVariantSelection(sizeInputs, colorInputs, variantIdInput, productVariants, sectionId, moneyFormat);
    }, 10);
  }
  
  // Apply initial color filter
  const currentSelectedColor = document.querySelector('.color-input:checked')?.value;
  const defaultColor = currentSelectedColor || 'Walnut';
  if (window.galleryInstance) {
    window.galleryInstance.filterByColor(defaultColor);
  }
  
  // Size selection
  sizeInputs.forEach(input => {
    input.addEventListener('change', function() {
      updateSizeStyles(sizeInputs);
      updateVariantSelection(sizeInputs, colorInputs, variantIdInput, productVariants, sectionId, moneyFormat);
    });
  });
  
  // Color selection  
  colorInputs.forEach(input => {
    input.addEventListener('change', function() {
      updateColorStyles(colorInputs);
      updateVariantSelection(sizeInputs, colorInputs, variantIdInput, productVariants, sectionId, moneyFormat);
      if (window.galleryInstance) {
        window.galleryInstance.scrollToColorImage(this.value);
      }
    });
  });
  
  // Initialize styles and price
  updateSizeStyles(sizeInputs);
  updateColorStyles(colorInputs);
  
  const initialSelectedSize = document.querySelector('.size-input:checked')?.value;
  const initialSelectedColor = document.querySelector('.color-input:checked')?.value;
  
  if (initialSelectedSize || initialSelectedColor) {
    const initialVariant = productVariants.find(variant => {
      return (variant.option1 === initialSelectedSize || variant.option2 === initialSelectedSize) &&
             (variant.option1 === initialSelectedColor || variant.option2 === initialSelectedColor);
    });
    
    if (initialVariant) {
      updatePriceDisplay(initialVariant, sectionId, moneyFormat);
      updateQuantityLimits(initialVariant, sectionId);
    }
  } else {
    const defaultVariant = productVariants.find(variant => variant.available) || productVariants[0];
    if (defaultVariant) {
      updatePriceDisplay(defaultVariant, sectionId, moneyFormat);
      updateQuantityLimits(defaultVariant, sectionId);
    }
  }
  
  // Handle quantity button clicks
  const quantityButtons = document.querySelectorAll('[data-quantity-change]');
  quantityButtons.forEach(button => {
    button.addEventListener('click', async function() {
      const change = parseInt(this.dataset.quantityChange);
      await updateQuantity(this, change, productVariants, sectionId);
    });
  });

  // Handle manual quantity input
  const quantityInput = document.querySelector('.quantity-input');
  if (quantityInput) {
    quantityInput.addEventListener('input', async function() {
      const currentVariant = productVariants.find(variant => variant.id == variantIdInput.value);
      
      if (currentVariant) {
        const maxQuantity = 10;
        const inputValue = parseInt(this.value);
        
        if (!isNaN(inputValue)) {
          if (inputValue > maxQuantity) {
            this.value = maxQuantity;
          } else if (inputValue < 1) {
            this.value = 1;
          }
        }
        
        const minusButton = document.querySelector('.quantity-minus');
        const plusButton = document.querySelector('.quantity-plus');
        const currentValue = parseInt(this.value) || 1;
        minusButton.disabled = currentValue <= 1;
        plusButton.disabled = currentValue >= maxQuantity;
        
        const inventoryStatus = document.getElementById(`inventory-status-${sectionId}`);
        const inventoryMessage = inventoryStatus?.querySelector('.inventory-message');
        updateInventoryStatus(currentVariant, maxQuantity, inventoryStatus, inventoryMessage);
      }
    });
  }
}

function updateSizeStyles(sizeInputs) {
  document.querySelectorAll('.size-option').forEach((option, index) => {
    const input = sizeInputs[index];
    if (input && input.checked) {
      option.classList.remove('border-gray-300', 'bg-white', 'text-gray-900');
      option.classList.add('border-gray-900', 'bg-gray-900', 'text-white');
    } else {
      option.classList.remove('border-gray-900', 'bg-gray-900', 'text-white');
      option.classList.add('border-gray-300', 'bg-white', 'text-gray-900');
    }
  });
}

function updateColorStyles(colorInputs) {
  document.querySelectorAll('.color-swatch').forEach((swatch, index) => {
    const input = colorInputs[index];
    if (input && input.checked) {
      swatch.classList.remove('border-gray-300');
      swatch.classList.add('border-gray-900', 'shadow-[0_0_0_3px_#FFFFFF,0_0_0_5px_#1A1A1A]');
    } else {
      swatch.classList.remove('border-gray-900', 'shadow-[0_0_0_3px_#FFFFFF,0_0_0_5px_#1A1A1A]');
      swatch.classList.add('border-gray-300');
    }
  });
}

function updateVariantSelection(sizeInputs, colorInputs, variantIdInput, productVariants, sectionId, moneyFormat) {
  const selectedSize = document.querySelector('.size-input:checked')?.value;
  const selectedColor = document.querySelector('.color-input:checked')?.value;
  
  const matchingVariant = productVariants.find(variant => {
    const hasSize = !selectedSize || variant.option1 === selectedSize || variant.option2 === selectedSize || variant.option3 === selectedSize;
    const hasColor = !selectedColor || variant.option1 === selectedColor || variant.option2 === selectedColor || variant.option3 === selectedColor;
    return hasSize && hasColor;
  });
  
  if (matchingVariant && variantIdInput) {
    variantIdInput.value = matchingVariant.id;
    updatePriceDisplay(matchingVariant, sectionId, moneyFormat);
    updateQuantityLimits(matchingVariant, sectionId);
  }
}

function updatePriceDisplay(variant, sectionId, moneyFormat) {
  const currentPrice = document.getElementById(`current-price-${sectionId}`);
  const discountSection = document.getElementById(`discount-section-${sectionId}`);
  const discountPercent = document.getElementById(`discount-percent-${sectionId}`);
  const comparePrice = document.getElementById(`compare-price-${sectionId}`);
  
  if (!variant || !currentPrice) return;
  
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = moneyFormat.replace('0.00', (variant.price / 100).toFixed(2));
  const formattedPrice = tempDiv.textContent;
  currentPrice.textContent = formattedPrice;
  
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    const discountPercentage = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    
    const tempCompareDiv = document.createElement('div');
    tempCompareDiv.innerHTML = moneyFormat.replace('0.00', (variant.compare_at_price / 100).toFixed(2));
    const formattedComparePrice = tempCompareDiv.textContent;
    
    discountPercent.textContent = `(${discountPercentage}% off)`;
    comparePrice.textContent = formattedComparePrice;
    discountSection.style.display = 'flex';
  } else {
    discountSection.style.display = 'none';
  }
}

function updateQuantityLimits(variant, sectionId) {
  const quantityInput = document.querySelector('.quantity-input');
  const minusButton = document.querySelector('.quantity-minus');
  const plusButton = document.querySelector('.quantity-plus');
  const inventoryStatus = document.getElementById(`inventory-status-${sectionId}`);
  const inventoryMessage = inventoryStatus?.querySelector('.inventory-message');
  
  if (!quantityInput || !variant) return;
  
  const maxQuantity = 10;
  const currentQuantity = parseInt(quantityInput.value) || 1;
  
  if (maxQuantity > 0) {
    quantityInput.setAttribute('max', maxQuantity);
  } else {
    quantityInput.removeAttribute('max');
  }
  
  if (currentQuantity > maxQuantity) {
    quantityInput.value = maxQuantity;
  }
  
  minusButton.disabled = parseInt(quantityInput.value) <= 1;
  plusButton.disabled = parseInt(quantityInput.value) >= maxQuantity;
  
  updateInventoryStatus(variant, maxQuantity, inventoryStatus, inventoryMessage);
}

// Export for use in Liquid template
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initProductHero, ProductGallery };
}

